import React, {Component} from 'react';
import style from '../css/activeBetsSummary.css';
// constants
import {
    AF_H2H,
    AMERICAN_FOOTBALL_MODULE,
    AWAY,
    BASEBALL,
    BASEBALL_MODULE,
    BASKET_BALL,
    BASKET_BALL_EURO,
    BASKETBALL_MODULE,
    BOTH, CRICKET,
    CRICKET_MODULE,
    FOOTBALL,
    FOOTBALL_MODULE,
    HOME,
    NFLA,
    RACING_MODULE,
    SOCCER3_FOOTBALL,
    TENNIS,
    TENNIS_MODULE
} from '../../../constants/identifiers';
import {BASE_VALUE} from '../../../constants/chips';
import {ASSETS_URL} from '../../../constants/endpoints';
import {VIRTUALS} from '../../../constants/games';
// helpers
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
import {
    getAFMarketNameByCode,
    getBasketballMarketNameByCode,
    getCricketMarketNameByCode,
    getFootballMarketNameByCode,
    getMarbleMarketNameByCode,
    getRacingMarketNameByCode,
    isHomeOrAwayTeamBet
} from '../helpers/marketHelpers';
import {TO_WIN} from '../modules/racing/constants/identifiers';
import {calculateEachWayValues} from '../../../helpers/eachWayBetHelpers';
import {hasEventTypeRacerNumberUI} from "../../simplified/modules/racing/helpers/racersHelper";
import {isMarbleEuroEvent, isMarbleEvent} from '../modules/racing/helpers/racersHelper';
import {roundNumber} from '../../../helpers/mathFunctions';
import {translateAFUnderOverLanguageBased} from '../modules/americanFootball/helpers/marketHelpers';
import {translateBasketballUnderOverLanguageBased} from '../modules/basketball/helpers/marketHelpers';
import {getPotentialReturn} from '../modules/matchday/helpers/matchdayHelper';
import {getMarketByCode} from '../modules/tennis/helpers/marketHelpers'
import { getBBMarketByCode, toSentenceCase } from '../modules/baseball/helpers/marketHelpers';

class ActiveBetsResume extends Component {

    _generateHistoryHeaderRow(eventType) {
        return (<div className={`${style.betHistoryRowHeader} ${style.title}`}>
            <div className={`${style.stake} ${style.title}`}>{getText('BET_TYPE_STAKE', this.props.store)}</div>
            <div className={`${style.selection} ${style.title}`}>{getText('SELECTION', this.props.store)}</div>
            <div
                className={`${style.potentialReturnsHeader} ${style.title}`}>{getText('POTENTIAL_RETURNS', this.props.store)}</div>
        </div>);
    }

    _getFootballSilkHome(bet) {
        if (isHomeOrAwayTeamBet(bet) !== HOME) return '';
        let storeData = this.props.store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        return (<img className={style.footballIconImage}
                     src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamOne}_Home.png`}
                     alt={`icon_${selectedEvent.teamOne}`}/>);
    }

    _getFootballSilkAway(bet) {
        if (isHomeOrAwayTeamBet(bet) !== AWAY) return '';
        let storeData = this.props.store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let awayTeamKit = selectedEvent.awayTeamKit.toString() === '0' ? 'Home' : 'Away';

        return (<img className={style.footballIconImage}
                     src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamTwo}_${awayTeamKit}.png`}
                     alt={`icon_${selectedEvent.teamTwo}`}/>);
    }

    _getFootballSilkBoth(bet) {
        if (isHomeOrAwayTeamBet(bet) !== BOTH) return '';
        let storeData = this.props.store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let awayTeamKit = selectedEvent.awayTeamKit.toString() === '0' ? 'Home' : 'Away';

        return (<div>
            <img className={style.footballIconImage}
                 src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamOne}_Home.png`}
                 alt={`icon_${selectedEvent.teamOne}`}/>
            <img className={style.footballIconImage}
                 src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/${selectedEvent.teamTwo}_${awayTeamKit}.png`}
                 alt={`icon_${selectedEvent.teamTwo}`}/>
        </div>);
    }

    _getSilks(bet, selections) {
        let storeData = this.props.store.getState().vpp;
        let gameChannel = storeData.games[storeData.selectedGameIndex].channel;
        let eventType = bet.EventType;
        let gameName = storeData.games[storeData.selectedGameIndex].name;

        switch (eventType) {
            case FOOTBALL:
            case SOCCER3_FOOTBALL:
            case BASKET_BALL:
            case BASKET_BALL_EURO:
            case NFLA:
            case AF_H2H:
            case CRICKET:
            case TENNIS:
            case BASEBALL:        
                return (<div className={style.activeBetsSummaryFootballIconContainer}>{selections}</div>);
            // racing events
            default:
                let num = bet.Market.Num;
                let marketCodeNums = bet.Market.Id;

                // forecast and tricast
                if (num.length > 1 && num.indexOf("-") > -1) {
                    let marketNums = (marketCodeNums.split('_'))[1].split('-');
                    return marketNums.map((mktNum, index) => {
                        return (<div className={style.doubleSelectionContainer}>
                            <img
                                src={`${ASSETS_URL}${VIRTUALS.find((game) => game.channel === gameChannel).URL.BMS_ASSETS}/silks/${isMarbleEuroEvent(eventType, gameName) ? 'combined/' : ''}silk${mktNum}.png`}
                                className={isMarbleEuroEvent(eventType, gameName) ? style.racerIconEuroMarble : style.racerIconImage}
                                key={index} alt={`icon${mktNum}`}
                            />
                            <div className={style.selectionNameNumContainer}>
                                {selections[index]}
                                {!(isMarbleEuroEvent(eventType, gameName)) ? hasEventTypeRacerNumberUI(eventType) ? (
                                    <div id={'slider_racer_number_' + mktNum}
                                         className={style.racerNumber}>{mktNum}</div>) : '' : ''}
                            </div>
                        </div>);
                    });
                } else {
                    return (<div key={num} className={style.singleSelectionContainer}>
                        <img
                            src={`${ASSETS_URL}${storeData.games[storeData.selectedGameIndex].assetsPath}/silks/${isMarbleEuroEvent(eventType, gameName) ? 'combined/' : ''}silk${num}.png`}
                            className={isMarbleEuroEvent(eventType, gameName) ? style.racerIconEuroMarble : style.racerIconImage}
                            alt={`icon${num}`}
                        />
                        <div className={style.selectionNameNumContainer}>
                            {selections[0]}
                            {!(isMarbleEuroEvent(eventType, gameName)) ? hasEventTypeRacerNumberUI(eventType) ? (
                                <div className={style.racerNumber}>{num}</div>) : '' : ''}
                        </div>
                    </div>);
                }
        }
    }

    _generateHistoryRowUI(bet, betIndex, selectionIndex) {
        let storeData = this.props.store.getState().vpp;
        let systemCurrency = storeData.systemCurrency;
        let type = storeData.games[storeData.selectedGameIndex].type;

        let marketDetails = this._generateMarketDetails(bet);
        let selectionUI = '';

        let selectionStyle = type === 'racing' ? marketDetails.name != undefined &&
        (marketDetails.name === getText('EACH_WAY', this.props.store)
            || marketDetails.name === getText('WIN', this.props.store)
            || marketDetails.name === getText('PLACE', this.props.store)
            || marketDetails.name === getText('SHOW', this.props.store)) ?
            style.selectionToWinText : style.selectionText : style.selectionTextMatch;

        if (marketDetails.selection !== undefined && marketDetails.selection.length > 0) {
            let selections = marketDetails.selection.map((selectionText, index) => {
                return (<div key={index} className={selectionStyle}>{selectionText}</div>);
            });

            selectionUI = (<div className={style.selection}>{this._getSilks(bet, selections)}</div>);
        }

        let potentialReturns = 0;
        if (bet.ExternalRefId !== undefined) {
            let ewIndividualStake = usingNonDecimalCurrency(systemCurrency) ? bet.Stake / 2 : roundNumber((bet.Stake / 2) / BASE_VALUE, 2);
            let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);
            let ewValues = calculateEachWayValues(ewIndividualStake, bet.Market.Price, marketInfo.eachWayRatio);
            potentialReturns = usingNonDecimalCurrency(systemCurrency) ? roundNumber(ewValues.potentialReturns, 0) : roundNumber(ewValues.potentialReturns, 2);
            //if(bet.PromoID != 'real_bet'){
                //let stake = usingNonDecimalCurrency(systemCurrency) ? bet.Stake : roundNumber((bet.Stake) / BASE_VALUE, 2);
                //potentialReturns = potentialReturns - stake;
            //}
        } else {
            potentialReturns = usingNonDecimalCurrency(systemCurrency) ? roundNumber(bet.Stake * bet.Market.Price, 0) : getPotentialReturn(bet.Market.Price, bet.Stake / BASE_VALUE, 1, 0);
            //Reduce stake from pot return if bet is probet
            if(bet.PromoId != 'real_bet'){
                let stake = usingNonDecimalCurrency(systemCurrency) ? bet.Stake : roundNumber((bet.Stake) / BASE_VALUE, 2);
                potentialReturns = potentialReturns - stake}
        }

        return (

            <div className={betIndex % 2 === 0
                ? style.betHistoryRowEven
                : style.betHistoryRowOdd} id={`${betIndex}_${bet.Market.Num}`} key={`${betIndex}_${selectionIndex}`}>
                <div
                    className={style.betTypeStake}>{`${marketDetails.name} - ${getFormattedCurrency(this.props.store, usingNonDecimalCurrency(systemCurrency) ? bet.Stake : (bet.Stake / BASE_VALUE).toFixed(2), 2)}`}</div>
                {selectionUI}
                <div
                    className={style.potentialReturns}>{`${getFormattedCurrency(this.props.store, potentialReturns, 2)}`}</div>
            </div>)
            ;
    }

    _generateMarketDetails(bet) {
        let module = getModuleFromEventType(bet.EventType);
        let marketName = '';
        let selection = '';

        switch (module) {
            case RACING_MODULE:

                if (bet.ExternalRefId !== undefined) {
                    marketName = getText('EACH_WAY', this.props.store);
                } else {
                    if (isMarbleEvent(bet.EventType)) {
                        let marbleMarket = getMarbleMarketNameByCode(bet.Market.Code);
                        marketName = getText(marbleMarket === TO_WIN.name ? 'WIN' : marbleMarket, this.props.store);
                    } else {
                        let raceMarket = getRacingMarketNameByCode(bet.Market.Code);
                        marketName = getText(raceMarket === TO_WIN.name ? 'WIN' : raceMarket, this.props.store);
                    }
                }

                if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
                    let marketDetails = JSON.parse(bet.OpaqueData);
                    if (marketDetails.racersInfo !== undefined && marketDetails.racersInfo.length > 0) {
                        selection = marketDetails.racersInfo.map((mi) => {
                            return `${mi.racer}`
                        })
                    }
                }
                break;
            case FOOTBALL_MODULE:
                let homeTeam = getText(bet.EventDetails.team1, this.props.store);
                let awayTeam = getText(bet.EventDetails.team2, this.props.store);

                marketName = getText(getFootballMarketNameByCode(bet.Market.Code), this.props.store, [homeTeam, awayTeam]);
                if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
                    let marketDetails = JSON.parse(bet.OpaqueData);
                    let name = isNaN(marketDetails.footballSelection)
                        ? getText(marketDetails.footballSelection, this.props.store, [homeTeam, awayTeam])
                        : marketDetails.footballSelection;
                    selection = [name];
                }
                break;
            case BASKETBALL_MODULE:
                let basketballHomeTeam = getText(bet.EventDetails.team2, this.props.store);
                let basketballAwayTeam = getText(bet.EventDetails.team1, this.props.store);

                marketName = getText(getBasketballMarketNameByCode(bet.Market.Code), this.props.store, [basketballHomeTeam, basketballAwayTeam]);
                if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
                    let marketDetails = JSON.parse(bet.OpaqueData);
                    let name;

                    if (basketballHomeTeam !== undefined && basketballAwayTeam !== undefined) {
                        if (marketDetails.basketballSelection.toLowerCase().indexOf('home') === 0) {
                            name = marketDetails.basketballSelection.replace(/Home/ig, basketballAwayTeam);
                        } else {
                            name = marketDetails.basketballSelection.replace(/Away/ig, basketballHomeTeam);
                        }
                        name = translateBasketballUnderOverLanguageBased(name, this.props.store);
                    } else if (marketDetails.basketballSelection.toLowerCase().indexOf('under') === 0) {
                        let number = marketDetails.basketballSelection.replace(/Under /ig, "");
                        name = getText('Under', this.props.store, [number]);
                    } else if (marketDetails.basketballSelection.toLowerCase().indexOf('over') === 0) {
                        let number = marketDetails.basketballSelection.replace(/Over /ig, "");
                        name = getText('Over', this.props.store, [number]);
                    } else if (isNaN(marketDetails.basketballSelection)) {
                        name = getText(marketDetails.basketballSelection, this.props.store);
                    } else {
                        name = marketDetails.basketballSelection;
                    }
                    if (name.toLowerCase().indexOf(' and ') > 0) {
                        let andText = ' ' + getText('and', this.props.store) + ' '
                        name = name.replace(/ And /ig, andText);
                    }

                    selection = [name];
                }
                break;
            case AMERICAN_FOOTBALL_MODULE:
                let afHomeTeam = getText(bet.EventDetails.team2, this.props.store);
                let afAwayTeam = getText(bet.EventDetails.team1, this.props.store);

                marketName = getText(getAFMarketNameByCode(bet.Market.Code), this.props.store, [afHomeTeam, afAwayTeam]);
                if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
                    let marketDetails = JSON.parse(bet.OpaqueData);
                    let name;

                    if (afAwayTeam !== undefined && marketDetails.afSelection.toLowerCase().indexOf('home') === 0) {
                        name = marketDetails.afSelection.replace(/Home/ig, afAwayTeam);
                        name = translateAFUnderOverLanguageBased(name, this.props.store);
                    } else if (afHomeTeam !== undefined && marketDetails.afSelection.toLowerCase().indexOf('away') === 0) {
                        name = marketDetails.afSelection.replace(/Away/ig, afHomeTeam);
                        name = translateAFUnderOverLanguageBased(name, this.props.store);
                    } else if (marketDetails.afSelection.toLowerCase().indexOf('under') === 0) {
                        let number = marketDetails.afSelection.replace(/Under /ig, "");
                        name = getText('Under', this.props.store, [number]);
                    } else if (marketDetails.afSelection.toLowerCase().indexOf('over') === 0) {
                        let number = marketDetails.afSelection.replace(/Over /ig, "");
                        name = getText('Over', this.props.store, [number]);
                    } else if (isNaN(marketDetails.afSelection)) {
                        name = getText(marketDetails.afSelection, this.props.store);
                    } else {
                        name = marketDetails.afSelection;
                    }
                    if (name.toLowerCase().indexOf(' and ') > 0) {
                        let andText = ' ' + getText('and', this.props.store) + ' '
                        name = name.replace(/ And /ig, andText);
                    }

                    selection = [name];
                }
                break;
            case CRICKET_MODULE:
                let cricketTeam1 = getText(bet.EventDetails.team1,this.props.store);
                let cricketTeam2 = getText(bet.EventDetails.team2,this.props.store);
                marketName = getText(getCricketMarketNameByCode(bet.Market.Code),this.props.store,[cricketTeam1,cricketTeam2]);
                if(typeof bet.OpaqueData !== 'undefined' && bet.OpaqueData !== ''){
                    let marketDetails = JSON.parse(bet.OpaqueData);
                    let name;
                    name = isNaN(marketDetails.cricketSelection) ?
                        marketDetails.cricketSelection.includes("Under") || marketDetails.cricketSelection.includes("Over") ?
                            getText(marketDetails.cricketSelection.split(" ")[0], this.props.store, [marketDetails.cricketSelection.split(" ")[1]])
                    : getText(marketDetails.cricketSelection,this.props.store,[cricketTeam1,cricketTeam2])
                    : marketDetails.cricketSelection;
                    selection = [name];
                }
                break;
                case TENNIS_MODULE:
                    let tennisHomeTeam = bet.EventDetails.team1.split(" ")[1];
                    let tennisAwayTeam = bet.EventDetails.team2.split(" ")[1];
                    marketName = getText(
                      getMarketByCode(bet.Market.Code).name,
                      this.props.store
                    );
                    if (
                      typeof bet.OpaqueData !== "undefined" &&
                      bet.OpaqueData !== ""
                    ) {
                      let marketDetails = JSON.parse(bet.OpaqueData);
                      let name;
                      let marketSelection = marketDetails.tennisSelection;
                      switch (Number(marketDetails.marketCode)) {
                        case 218:
                          name = marketSelection.split(" ")[1];
                          break;
                        case 219:
                          marketSelection = marketSelection
                            .replace("Player 1", tennisHomeTeam)
                            .replace("To Win", "")
                            .trim();
                          marketSelection = marketSelection
                            .replace("Player 2", tennisAwayTeam)
                            .replace("To Win", "")
                            .trim();
                          name = marketSelection;
                          break;
                        case 220:
                          name = getText(
                            marketSelection.split(" ")[0],
                            this.props.store,
                            [marketSelection.split(" ")[1]]
                          );
                          break;
                        case 221:
                          name = marketSelection;
                          break;
                        case 222:
                          name = marketSelection.includes("Player 1")
                            ? tennisHomeTeam +
                              " " +
                              getText(
                                marketSelection.replace("Player 1", "").trim(),
                                this.props.store
                              )
                            : tennisAwayTeam +
                              " " +
                              getText(
                                marketSelection.replace("Player 2", "").trim(),
                                this.props.store
                              );
                          break;
                        default:
                          name = getText(marketSelection, this.props.store);
                          break;
                      }
                      selection = [name];
                    }
                    break;    
                case BASEBALL_MODULE:
                    let teamOne = bet.EventDetails.homeTeam.trim();
                    let teamTwo = bet.EventDetails.awayTeam.trim();
                    let homeTeamBB =
                      teamOne.split(" ").length > 2
                        ? teamOne.split(" ")[2]
                        : teamOne.split(" ")[1];
                    let awayTeamBB =
                      teamTwo.split(" ").length > 2
                        ? teamTwo.split(" ")[2]
                        : teamTwo.split(" ")[1];
                    marketName = toSentenceCase(getText(
                        getBBMarketByCode(bet.Market.Code).name,
                        this.props.store, [homeTeamBB, awayTeamBB]
                    ));
                    if (
                      typeof bet.OpaqueData !== "undefined" &&
                      bet.OpaqueData !== ""
                    ) {
                        let marketDetails = JSON.parse(bet.OpaqueData);
                        let name;
                        let marketSelection = marketDetails.baseballSelection;
                        switch(Number(marketDetails.marketCode)){
                        case 244:
                        case 250:
                        case 251:
                            name = toSentenceCase(getText(marketSelection.split("_")[0],this.props.store))+" "+marketSelection.split("_")[1]+"."+marketSelection.split("_")[2];
                            break;
                        case 247:
                         if(bet.Market.Num<=2){
                          name = getText(marketSelection,this.props.store,[toSentenceCase(homeTeamBB)])
                         }
                         else if(bet.Market.Num>2&&bet.Market.Num<=4){
                          name = getText(marketSelection,this.props.store,[toSentenceCase(awayTeamBB)])
                         }
                         else{
                          name = getText(marketSelection,this.props.store)
                         }
                          break;
                        case 245:
                          name = marketSelection.replace(" Home Runs","");
                          break;
                        default:
                          name = marketSelection;
                          break;
                        }
                        selection = [name];
                    }
                    break;
            default:
                break;
        }

        return {name: marketName, selection}
    }

    render() {
        let activeBets = this.props.activeBets;

        let header = '';
        let content;

        if (activeBets && activeBets.length > 0) {
            header = this._generateHistoryHeaderRow(activeBets[0].Bets[0].EventType);
            content = activeBets.map((ab, selectionIndex) => ab.Bets.map((bet, betIndex) => this._generateHistoryRowUI(bet, selectionIndex, betIndex)))
        } else {
            content = getText('NO_BETS_RESUME', this.props.store)
        }
        return (<div className={style.activeBetsResume}>
            <div className={style.summaryTitle}>{getText('BET_SUMMARY', this.props.store)}</div>
            {header}
            {content}
        </div>);
    }
}

export default ActiveBetsResume;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/activeBetsSummary.js